import React from 'react';
import PropTypes from 'prop-types';

export const EmailLink = ({
  emailAddress,
  cc,
  bcc,
  subject,
  body,
  children,
}) => {
  const spaceFormatter = string => {
    let formattedString = string;
    if (formattedString.includes(' ')) {
      formattedString = string.replaceAll(' ', '%20');
    }

    return formattedString;
  };
  return (
    <a
      href={`mailto:${emailAddress}?cc=${cc}&bcc=${bcc}&subject=${spaceFormatter(
        subject
      )}&body=${spaceFormatter(body)}`}
    >
      {children}
    </a>
  );
};

EmailLink.propTypes = {
  emailAddress: PropTypes.string.isRequired,
  cc: PropTypes.string,
  bcc: PropTypes.string,
  subject: PropTypes.string,
  body: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

EmailLink.defaultProps = {
  cc: '',
  bcc: '',
  subject: '',
  body: '',
  children: '',
};
